import {
	AUTH_ERROR,
	GAME_MAINTENANCE,
	GAME_NOT_AVAILABLE,
	GAME_NOT_FOUND,
	GET_ERRORS,
	GET_ITEMS,
	GET_KEY,
	GET_RESULT,
	INSUFFICIENT_TICKET,
	ITEMS_LOADING,
	LOAD_COUPON,
	USER_LOADED,
	USER_LOADING,
} from "actions/types";
import { createContext, useReducer } from "react";

const initialState = {
	items: [],
	app_key: "",
	auth: {
		token: null,
		coupon: 0,
		game: null,
		device: null,
		user: null,
	},
	isAuthenticated: false,
	isLoading: true,
	error: { msg: "" },
};

function reducer(state, action) {
	switch (action.type) {
		case ITEMS_LOADING:
		case USER_LOADING:
			return {
				...state,
				isLoading: true,
			};
		case GET_ITEMS:
			return { ...state, items: action.payload, isLoading: false };
		case GET_KEY:
			return {
				...state,
				app_key: action.payload,
			};
		case GET_RESULT:
			return {
				...state,
				auth: { ...state.auth, coupon: state.auth.coupon - (action.payload.tier || 1) },
			};
		case USER_LOADED:
			return {
				...state,
				isAuthenticated: true,
				isLoading: false,
				auth: {
					token: action.payload.data.access_token,
					coupon: parseInt(action.payload.data.coupon),
					game: action.payload.data.game,
					device: action.payload.data.device,
					user: action.payload.data.userid,
				},
			};
		case LOAD_COUPON:
			return {
				...state,
				isAuthenticated: true,
				isLoading: false,
				auth: {
					...state.auth,
					coupon: parseInt(action.payload.data.coupon),
				},
			};
		case AUTH_ERROR:
			return {
				...state,
				isAuthenticated: false,
				isLoading: false,
				auth: {
					token: null,
					coupon: 0,
					game: null,
					user: null,
				},
			};
		case GET_ERRORS:
			return {
				...state,
				error: { msg: action.payload.msg },
			};
		case GAME_MAINTENANCE:
			return {
				...state,
				error: { msg: "Mohon Maaf Minigames Sedang Dalam Maintenance." },
			};
		case GAME_NOT_FOUND:
			return {
				...state,
				error: { msg: "Mohon Maaf Minigames Belum Tersedia Untuk Saat Ini." },
			};
		case GAME_NOT_AVAILABLE:
			return {
				...state,
				error: { msg: "Mohon Maaf Anda Kurang Beruntung Untuk Mengikuti Event Ini." },
			};
		case INSUFFICIENT_TICKET:
			return {
				...state,
				error: { msg: "Mohon Maaf Ticket Anda Tidak Mencukupi Untuk Mengikuti Event Ini." },
			};
		default:
			return state;
	}
}
export const Store = createContext();
export function StoreProvider({ children }) {
	const [state, dispatch] = useReducer(reducer, initialState);

	return <Store.Provider value={{ state, dispatch }}>{children}</Store.Provider>;
}
